import IDcustomisation from "./IDcustomisation";
export default IDcustomisation;
